/* global Products, _ */
import _Singleton, { deferredSingletonExport } from '@/tools/singleton';
import jquery from 'jquery';

// lodash
import _get from 'lodash/get';
import _head from 'lodash/head';
import _includes from 'lodash/includes';
import _keys from 'lodash/keys';
import _split from 'lodash/split';
import _toString from 'lodash/toString';

import ajaxShop from '@/ajax/shop';
import Client from '@/shop/client';
import Config from '@/shop/config';
import Money from '@/shop/money';
import PageData from '@/shop/page';
import Units from '@/shop/units';

/**
 * @class
 *
 * @description
 * Класс для работы с вспомогательным функционалом магазинв
 */
var Shop = function() {
  var self = this;

  self.config = new Config(self);
  self.money = new Money(self);
  self.client = new Client(self);
  self.pageData = new PageData();
  self.units = new Units(self);
};

/**
 * Отправка сообщений
 *
 * @method
 *
 * @param {Object} message - объект сообщения
 *
 * @return {jquery.ajax} - поток задачи
 *
 * @example
 * Shop.sendMessage({
 *   'from': 'json@test.ru',
 *   'name': 'test is my name',
 *   'subject': 'test is my subject',
 *   'content': 'YAAAAR!!!!',
 *   'phone': '+00000000000000'
 * })
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */
Shop.prototype.sendMessage = function(message) {
  return ajaxShop.message(message);
};

/**
 * @description
 * Отправка отзыва к товару
 *
 * @param {Object} review - объект с отзывом. ОБЯЗАТЕЛЬНО
 * @param {String} review.author - автор отзыва. ОБЯЗАТЕЛЬНО
 * @param {String} review.email - e-mail посетителя. ОБЯЗАТЕЛЬНО
 * @param {String} review.content - тело отзыва.ОБЯЗАТЕЛЬНО
 * @param {String} review.captcha_solution - капча. ОБЯЗАТЕЛЬНО
 * @param {String} review.captcha_challenge - капча. ОБЯЗАТЕЛЬНО
 * @param {Number} review.rating - капча.
 * @param {Object} options - дополнительные параметры
 * @param {Number} options.id - ID товара, к которому хотим оставить отзыв
 *
 * @return {Promise} - поток выполнения задачи
 */
Shop.prototype.sendReview = function(review, options) {
  var _review = review.review ? review.review : review;
  var _id = _get(options, 'id');

  var checkImageReview = _includes(_keys(_review), 'image_attributes][image');

  if (checkImageReview) {
    var form_data = new FormData();

    for (var name in _review) {
      form_data.append('review[' + name + ']', _review[name]);
    }

    _review = form_data;
  }

  return Products.get(_id)
    .then(function(product) {
      return product.url.split('?')[0];
    })
    .then(function(url) {
      if (checkImageReview) {
        return ajaxShop.reviewImage(_review, url);
      }

      return ajaxShop.review(_review, url);
    });
};

/**
 * @description
 * Отправка отзыва к статье
 *
 * @param {Object} comment - объект с комментарием. ОБЯЗАТЕЛЬНО
 * @param {String} comment.author - автор комментария. ОБЯЗАТЕЛЬНО
 * @param {String} comment.email - e-mail посетителя. ОБЯЗАТЕЛЬНО
 * @param {String} comment.content - тело комментария.ОБЯЗАТЕЛЬНО
 * @param {String} comment.captcha_solution - капча. ОБЯЗАТЕЛЬНО
 * @param {String} comment.captcha_challenge - капча. ОБЯЗАТЕЛЬНО
 * @param {Object} options - объект с доп параметрами
 * @param {Number} options.url - url стать, к которой хотим оставить комментарий
 *
 * @return {Promise} - поток выполнения задачи
 */
Shop.prototype.sendComment = function(comment, options) {
  var _comment = comment.comment ? comment.comment : comment;
  var _url = _head(_split(_get(options, 'url', window.location.pathname), '?'));

  return ajaxShop.comment(_comment, _url);
};

/**
 * @public
 * Получение комментариев товара
 * @return {String}
 * возвращает массив отзывов к товару.
 */
Shop.prototype.getProductReviews = function(id) {
  var self = this;
  var result = jquery.Deferred();
  var product_id = _toString(id) || self.config.getProductId();

  ajaxAPI.shop.product.getReviews(product_id)
    .done(function(reviews) {
      result.resolve(reviews);
    })
    .fail(function(error) {
      result.reject(error);
    });

  return result.promise();
};

/**
 * @public
 * Получение комментариев статьи
 * @return {String}
 * возвращает массив отзывов к статье.
 */
Shop.prototype.getArticleComments = function(id) {
  var self = this;
  var result = jquery.Deferred();
  var article_id = _toString(id) || self.config.getArticleId();

  ajaxAPI.shop.article.getComments(article_id)
    .done(function(comments) {
      result.resolve(comments);
    })
    .fail(function(error) {
      result.reject(error);
    });

  return result.promise();
};

export default deferredSingletonExport(_Singleton(Shop), Shop);
